'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

var _reactIntl = require('react-intl');

var _axwayReactIntl = require('axway-react-intl');

var _axwayReactIntl2 = _interopRequireDefault(_axwayReactIntl);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _accessibilityUtils = require('./accessibilityUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A check list component
 */
var CheckList = function (_React$Component) {
	_inherits(CheckList, _React$Component);

	function CheckList(props) {
		_classCallCheck(this, CheckList);

		var _this = _possibleConstructorReturn(this, (CheckList.__proto__ || Object.getPrototypeOf(CheckList)).call(this, props));

		_axwayReactIntl2.default.init(_this);
		_this.onSelectAll = _this.onSelectAll.bind(_this);
		_this.onChecked = _this.onChecked.bind(_this);

		// iterate through all children and initialize an internal state with each
		// of their initialized checked state.  this component will maintain the
		// state, not the children.
		var checked = {};
		_react2.default.Children.forEach(_this.props.children, function (child, i) {
			checked[i] = child.props.checked;
		});
		_this.state = { checked: checked };
		return _this;
	}

	_createClass(CheckList, [{
		key: 'onChecked',
		value: function onChecked(index) {
			// toggle the child state and trigger a render
			this.state.checked[index] = !this.state.checked[index];
			this.setState({
				checked: this.state.checked
			});
			this.notifyChange();
		}
	}, {
		key: 'notifyChange',
		value: function notifyChange() {
			var _this2 = this;

			var changed = [];
			Object.keys(this.state.checked).map(function (a) {
				return changed.push(_this2.state.checked[a]);
			});
			if (this.props.onChange) {
				this.props.onChange(changed);
			}
		}
	}, {
		key: 'onSelectAll',
		value: function onSelectAll() {
			var _this3 = this;

			var toggle = !this.isSelectAllChecked();
			Object.keys(this.state.checked).forEach(function (key) {
				_this3.state.checked[key] = toggle;
			});
			this.setState({ checked: this.state.checked }, function () {
				_this3.notifyChange();
			});
		}
	}, {
		key: 'isSelectAllChecked',
		value: function isSelectAllChecked() {
			var _this4 = this;

			return Object.keys(this.state.checked).every(function (key) {
				return _this4.state.checked[key];
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _this5 = this;

			var _props = this.props,
			    className = _props.className,
			    disabled = _props.disabled,
			    striped = _props.striped,
			    selectAll = _props.selectAll;


			var children = _react2.default.Children.map(this.props.children, function (child, i) {
				return _react2.default.cloneElement(child, {
					index: i,
					disabled: disabled || false,
					checked: _this5.state.checked[i],
					onChange: _this5.onChecked
				});
			});

			var selectAllChecked = this.isSelectAllChecked();
			var classes = (0, _classnames2.default)('check-list', className, { striped: striped });

			return _react2.default.createElement(
				'div',
				{ className: classes },
				selectAll && _react2.default.createElement(
					'div',
					{ className: 'row' },
					_react2.default.createElement(
						'div',
						{ className: 'col-xs-12 noselect' },
						_react2.default.createElement(
							_reactBootstrap.Checkbox,
							{
								inline: true,
								className: 'select-all',
								disabled: disabled,
								checked: selectAllChecked,
								onChange: this.onSelectAll,
								onKeyPress: function onKeyPress(e) {
									(0, _accessibilityUtils.OnActionKey)(e, _this5.selectAll);
								}
							},
							this.intl.formatMsg('Select all')
						)
					)
				),
				children
			);
		}
	}]);

	return CheckList;
}(_react2.default.Component);

CheckList.propTypes = {
	/**
  * The class name to apply to the fieldset.
  */
	className: _propTypes2.default.string,

	/**
  * If this boolean is set, the form controls that are its descendants, except
  * descendants of its first optional <legend> element are disabled.
  */
	disabled: _propTypes2.default.bool,

	/**
  * Alternate row highlights
  */
	striped: _propTypes2.default.bool,

	/**
  * Enables select-all button.
  */
	selectAll: _propTypes2.default.bool,

	/**
  * Child label
  */
	children: function children(props, propName, componentName) {
		var prop = props[propName];
		var error = null;
		_react2.default.Children.forEach(prop, function (child) {
			if (!error && child.type.displayName !== 'CheckListItem') {
				error = new Error(componentName + ' children should be of type \'CheckListItem\'');
			}
		});
		return error;
	},

	/**
  * Callback
  */
	onChange: _propTypes2.default.func
};

CheckList.defaultProps = {
	className: '',
	disabled: false,
	selectAll: true,
	striped: false
};

var CheckListItem = function (_React$Component2) {
	_inherits(CheckListItem, _React$Component2);

	function CheckListItem(props) {
		_classCallCheck(this, CheckListItem);

		var _this6 = _possibleConstructorReturn(this, (CheckListItem.__proto__ || Object.getPrototypeOf(CheckListItem)).call(this, props));

		_this6.onChecked = _this6.onChecked.bind(_this6);
		return _this6;
	}

	_createClass(CheckListItem, [{
		key: 'onChecked',
		value: function onChecked() {
			if (this.props.onChange) {
				// emit this index
				this.props.onChange(this.props.index);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this7 = this;

			var _props2 = this.props,
			    description = _props2.description,
			    disabled = _props2.disabled,
			    children = _props2.children,
			    checked = _props2.checked,
			    value = _props2.value;

			return _react2.default.createElement(
				'div',
				{ className: 'row check-list-item' },
				_react2.default.createElement(
					'div',
					{ className: 'col-xs-6 noselect' },
					_react2.default.createElement(
						_reactBootstrap.Checkbox,
						{
							inline: true,
							value: value,
							disabled: disabled,
							checked: checked,
							onChange: this.onChecked,
							onKeyPress: function onKeyPress(e) {
								// space already handled
								(0, _accessibilityUtils.OnKey)(e, [_accessibilityUtils.Keys.enter], _this7.onChecked);
							}
						},
						children
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'col-xs-6 text-right', disabled: disabled },
					description
				)
			);
		}
	}]);

	return CheckListItem;
}(_react2.default.Component);

CheckListItem.propTypes = {
	/**
  * Controls the checked state of the item.
  */
	checked: _propTypes2.default.bool,
	/**
  * Disables checkbox
  */
	disabled: _propTypes2.default.bool,

	/**
  * Optional description
  */
	description: _propTypes2.default.string,

	/**
  * Child label
  */
	children: _propTypes2.default.string,

	/**
  * Callback
  */
	onChange: _propTypes2.default.func,

	/**
  * Callback when an individual item is checked
  */
	onChecked: _propTypes2.default.func,

	/**
  * Internal index.  Do not use.
  */
	index: _propTypes2.default.number
};

CheckListItem.defaultProps = {
	checked: false,
	disabled: false
};

CheckList.Item = CheckListItem;
CheckList.Item.displayName = 'CheckListItem';

var CheckListIntl = (0, _reactIntl.injectIntl)(CheckList);

CheckListIntl.Item = CheckListItem;

var _default = CheckListIntl;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(CheckList, 'CheckList', 'src/components/CheckList.jsx');

	__REACT_HOT_LOADER__.register(CheckListItem, 'CheckListItem', 'src/components/CheckList.jsx');

	__REACT_HOT_LOADER__.register(CheckListIntl, 'CheckListIntl', 'src/components/CheckList.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/CheckList.jsx');
}();

;